import { CSElement } from "./CSElement";

export class ElementRegistry {
  private readonly registry = new Map<string, CSElement>();

  public get totalElementsCount(): number {
    return this.registry.size;
  }

  public register(element: CSElement): void {
    this.registry.set(element.id, element);
  }

  public unregister(element: CSElement): void {
    this.registry.delete(element.id);
  }

  public getElementById(id: string): CSElement | null {
    return this.registry.get(id) || null;
  }

  public getElementsByName(name: string): CSElement[] {
    const result: CSElement[] = [];
    this.registry.forEach(element => {
      if (element.name === name) {
        result.push(element);
      }
    });
    return result;
  }

  public getAllElements(): CSElement[] {
    return Array.from(this.registry.values());
  }

  public clear(): void {
    this.registry.clear();
  }
} 